export default __webpack_public_path__ + "static/media/1372.a68434ce.png";